import {
  DYNAMIC_CONTENT,
  LOADING_CONTENT,
  CLEAN_STORE,
  SHOW_BANNER,
  DYNAMIC_CONTENT_TYP,
} from "../types/dynamicContent";

const initialState = {
  dynamicContent: null,
  loading: false,
  nameCampaign: "",
  showBanner: false,
  dynamicContentTYP: [],
};

const dynamicContentReducer = (state = initialState, action) => {
  switch (action.type) {
    case DYNAMIC_CONTENT:
      return {
        ...state,
        dynamicContent: action.payload,
      };
    case LOADING_CONTENT:
      return {
        ...state,
        loading: action.payload,
      };
    case CLEAN_STORE:
      return initialState;
    case SHOW_BANNER:
      return {
        ...state,
        showBanner: action.payload,
      };
    case DYNAMIC_CONTENT_TYP:
      return {
        ...state,
        dynamicContentTYP: action.payload,
      };
    default:
      return state;
  }
};

export default dynamicContentReducer;
